import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import InlineAlert from "components/InlineAlert";
import { employeesService } from "services";

const EmployeePendingConfigurationWarnings = ({
	employeeId,
	onNavigate,
	refreshKey = 0,
	className = "",
}) => {
	const { t } = useTranslation();
	const [missing, setMissing] = useState(null);

	useEffect(() => {
		let mounted = true;

		if (!employeeId) {
			setMissing(null);
			return undefined;
		}

		setMissing(null);

		Promise.all([
			employeesService.getGroups(employeeId),
			employeesService.getContracts(employeeId),
		])
			.then(([groups, contracts]) => {
				if (!mounted) return;
				setMissing({
					group: Array.isArray(groups) && groups.length === 0,
					contract: Array.isArray(contracts) && contracts.length === 0,
				});
			})
			.catch(() => {
				if (mounted) setMissing(null);
			});

		return () => {
			mounted = false;
		};
	}, [employeeId, refreshKey]);

	if (!missing || (!missing.group && !missing.contract)) {
		return null;
	}

	const warning = (type, tab) => (
		<InlineAlert key={type} variant="warning">
			{t(`employee.configurationWarnings.${type}.message`)}{" "}
			<button
				type="button"
				className="inline-alert__details-link"
				onClick={() => onNavigate(tab)}
			>
				{t(`employee.configurationWarnings.${type}.action`)}
			</button>
		</InlineAlert>
	);

	return (
		<div className={`d-flex flex-column gap-2 ${className}`.trim()}>
			{missing.group && warning("missingGroup", "grupos")}
			{missing.contract && warning("missingContract", "contratos")}
		</div>
	);
};

export default EmployeePendingConfigurationWarnings;
